// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zifObbLJqhBM6i {
  display: block;
  align-items: center;
  justify-content: left;
  padding: var(--ds-space-150, 12px) var(--ds-space-025, 2px) var(--ds-space-150, 12px) var(--ds-space-150, 12px);
  color: var(--ds-text-inverse, #ffffff);
  font-family: var(--ds-font-family-body, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif);
  font-weight: var(--ds-font-weight-regular, 400);
}
.zifObbLJqhBM6i.fDBgEcIuOknWMe {
  display: flex;
  flex-direction: row;
}
.YMdaZzZfdEap3G {
  box-shadow: var(--ds-shadow-raised, 0px 1px 1px #091e4240, 0px 0px 1px #091e424f);
}
.RNuzbS2Tv2WMRZ {
  display: flex;
}
.dWaSMxjPU9uehq {
  flex-grow: 1;
  width: 100%;
  margin-top: var(--ds-space-100, 7px);
  color: var(--ds-text, #172b4d);
  font-size: 20px;
  font-weight: var(--ds-font-weight-semibold, 600);
}
.dWaSMxjPU9uehq.bqQm1Tk9PiEoJ9,
.dWaSMxjPU9uehq.bqQm1Tk9PiEoJ9 a {
  color: var(--ds-text-inverse, #ffffff);
}
.waUQSj_Hpi3H9Y {
  border-radius: var(--ds-border-radius-100, 3px);
}
.HxWww1fHxL6mHF {
  align-self: flex-start;
  justify-self: right;
  cursor: pointer;
}
.J98lVmqBZTnNqt {
  flex-grow: 1;
  padding-right: var(--ds-space-075, 6px);
  color: var(--ds-text, #172b4d);
  font-size: 14px;
  line-height: 24px;
}
.J98lVmqBZTnNqt a {
  color: var(--ds-text, #172b4d);
}
.J98lVmqBZTnNqt.bqQm1Tk9PiEoJ9,
.J98lVmqBZTnNqt.bqQm1Tk9PiEoJ9 a {
  color: var(--ds-text-inverse, #ffffff);
}
`, ""]);
// Exports
export var narrowBannerContainer = `zifObbLJqhBM6i`;
export var noHeader = `fDBgEcIuOknWMe`;
export var bannerShadow = `YMdaZzZfdEap3G`;
export var topRow = `RNuzbS2Tv2WMRZ`;
export var headerBody = `dWaSMxjPU9uehq`;
export var lightText = `bqQm1Tk9PiEoJ9`;
export var roundedCorners = `waUQSj_Hpi3H9Y`;
export var closeButton = `HxWww1fHxL6mHF`;
export var textContent = `J98lVmqBZTnNqt`;
export default ___CSS_LOADER_EXPORT___;
